import {
  SET_ACTIVE_PLAYLIST,
  CREATE_PLAYLIST_EVENT,
  DELETE_PLAYLIST_EVENT,
  SET_LAYOUTS,
  UPDATE_EVENT,
} from '@/store/actions/playlisteditor';

const state = () => ({
  activePlaylist: {},
  layouts: [],
});

/* eslint-disable no-shadow, arrow-body-style */
const getters = {
  getActivePlaylist: (state) => state.activePlaylist,
  getLayouts: (state) => state.layouts,
};
/* eslint-enable */

const actions = {
  SET_ACTIVE_PLAYLIST: ({ commit }, playlist) => {
    commit(SET_ACTIVE_PLAYLIST, playlist);
  },
  CREATE_PLAYLIST_EVENT: ({ commit }, payload) => {
    commit(CREATE_PLAYLIST_EVENT, payload);
  },
  DELETE_PLAYLIST_EVENT: ({ commit }, index) => {
    commit(DELETE_PLAYLIST_EVENT, index);
  },
  SET_LAYOUTS: ({ commit }, payload) => {
    commit(SET_LAYOUTS, payload);
  },
  UPDATE_EVENT: ({ commit }, payload) => {
    commit(UPDATE_EVENT, payload);
  },
};

/* eslint-disable no-shadow, arrow-body-style, no-param-reassign */
const mutations = {
  SET_ACTIVE_PLAYLIST: (state, playlist) => {
    state.activePlaylist = playlist;
  },
  CREATE_PLAYLIST_EVENT: (state, payload) => {
    state.activePlaylist.events.push(payload);
  },
  DELETE_PLAYLIST_EVENT: (state, index) => {
    state.activePlaylist.events.splice(index, 1);
  },
  SET_LAYOUTS: (state, payload) => {
    state.layouts = payload;
  },
  UPDATE_EVENT: (state, payload) => {
    payload.data.forEach((data) => {
      // console.log("UPDATE_EVENT "+data.index+" "+data.key+" "+data.value);
      // only end time or duration can be entered
      if (data.key === 'end_time') state.activePlaylist.events[data.index].duration = null;
      if (data.key === 'duration') state.activePlaylist.events[data.index].end_time = null;

      state.activePlaylist.events[data.index][data.key] = data.value;
    });
  },
};
/* eslint-enable */

export default {
  state,
  getters,
  actions,
  mutations,
};
